import { render } from "./Main.vue?vue&type=template&id=55daca02&scoped=true&ts=true"
import script from "./ts/main/mainHelper.ts?vue&type=script&lang=ts"
export * from "./ts/main/mainHelper.ts?vue&type=script&lang=ts"

import "./Main.vue?vue&type=style&index=0&id=55daca02&scoped=true&lang=scss"

import exportComponent from "D:\\tools\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-55daca02"]])

export default __exports__